var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { EmbedComponentsProvider } from '../context/embed-components-context';
import { useEmbedComponents } from '../hooks/use-embed-components';
import { ListItemWithIcon } from '../elements/list-item-with-icon';
import { ContentTitle } from '../elements/content-title';
import { filter } from 'lodash';
import { ContentEntityIntro } from './content-entity-intro';
import { ContentEntityContent } from './content-entity-content';
import { useLang } from '../hooks/use-lang';
import { useEntityOptions } from '../hooks/use-entity-options';
import { TickIcon } from '@shapeable/icons';
import { useComponents } from '../context/component-context';
import { useComponentPropsFor } from '../context/component-props-context';
import { LinkEntityButton } from './link-entity-button';
var cls = classNames('content-entity-block');
export var ContentEntityBlockDefaultProps = {
  center: false,
  colors: {
    text: 'strong'
  }
};
// -------- Styles -------->
var MarginStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: ", ";\n    gap: ", ";\n  "], ["\n    margin-top: ", ";\n    gap: ", ";\n  "])), theme.UNIT(4), theme.UNIT(3))
});
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 300;\n    color: ", ";\n    ", ";\n\n    b, strong {\n      color: ", ";\n    }\n  "], ["\n    font-weight: 300;\n    color: ", ";\n    ", ";\n\n    b, strong {\n      color: ", ";\n    }\n  "])), theme.COLOR('text'), theme.APPLY_COLORS, theme.COLOR('primary')),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var center = _a.center;
    return center && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      text-align: center;\n      justify-content: center;\n      justify-self: center;\n    "], ["\n      text-align: center;\n      justify-content: center;\n      justify-self: center;\n    "])));
  })
});
var TitlesStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), MarginStyles)
});
var TitleStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: 0 !important;\n    font-weight: 500;\n    line-height: 1.15em;\n    font-size: 1.75em;\n    margin-bottom: ", ";\n    color: inherit;\n  "], ["\n    margin-top: 0 !important;\n    font-weight: 500;\n    line-height: 1.15em;\n    font-size: 1.75em;\n    margin-bottom: ", ";\n    color: inherit;\n  "])), theme.UNIT(1))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    color: ", ";\n    margin-top: 0;\n    font-weight: 400;\n    margin-bottom: ", ";\n  "], ["\n    color: ", ";\n    margin-top: 0;\n    font-weight: 400;\n    margin-bottom: ", ";\n  "])), theme.COLOR('strong'), theme.UNIT(1))
});
var ContentStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: ", ";\n    \n    font-size: 1em;\n    ", ";\n  "], ["\n    color: ", ";\n    \n    font-size: 1em;\n    ", ";\n  "])), theme.COLOR('text'), MarginStyles)
});
var IntroStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(6))
});
var LinkStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    justify-self: flex-start;\n    margin-top: ", ";\n    width: 100%;\n  "], ["\n    justify-self: flex-start;\n    margin-top: ", ";\n    width: 100%;\n  "])), theme.UNIT(3)),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    max-width: 400px; \n  "], ["\n    max-width: 400px; \n  "])))
});
var TitleLinkStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    text-decoration: none;\n    display: inline-block;\n    color: inherit;\n    &:hover {\n      color: ", ";\n\n      * {\n        color: ", ";\n      }\n\n    }\n  "], ["\n    text-decoration: none;\n    display: inline-block;\n    color: inherit;\n    &:hover {\n      color: ", ";\n\n      * {\n        color: ", ";\n      }\n\n    }\n  "])), theme.COLOR('link-hover'), theme.COLOR('link-hover'))
});
var PageLinkStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LinkStyles)
});
var ButtonsStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", ";\n    display: flex;\n    flex-direction: column;\n    ", "\n  "], ["\n    ", ";\n    display: flex;\n    flex-direction: column;\n    ", "\n  "])), MarginStyles, function (_a) {
    var center = _a.center;
    return center && css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      align-items: center;\n\n      a, button {\n        width: auto;\n        max-width: none;\n      }\n    "], ["\n      align-items: center;\n\n      a, button {\n        width: auto;\n        max-width: none;\n      }\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Titles: styled.div.attrs(cls.attr('titles'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  Title: styled(ContentTitle).attrs(cls.attr('title'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  TitleLink: styled.a.attrs(cls.attr('title-link'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TitleLinkStyles),
  Subtitle: styled.h2.attrs(cls.attr('subtitle'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Content: styled(ContentEntityContent).attrs(cls.attr('content'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Intro: styled(ContentEntityIntro).attrs(cls.attr('intro'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  LinkButton: styled(LinkEntityButton)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), PageLinkStyles),
  Buttons: styled.div.attrs(cls.attr('buttons'))(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles)
};
export var ContentEntityBlock = function (props) {
  var _a = useComponentPropsFor('ContentEntityBlock', ContentEntityBlockDefaultProps, props),
    className = _a.className,
    children = _a.children,
    entity = _a.entity,
    titleHref = _a.titleHref,
    center = _a.center,
    afterTitle = _a.afterTitle,
    afterSubtitle = _a.afterSubtitle,
    afterIntro = _a.afterIntro,
    afterContent = _a.afterContent,
    colors = _a.colors;
  var intro = entity.intro,
    title = entity.title,
    subtitle = entity.subtitle,
    content = entity.content;
  var hasContent = content && content.text;
  var contentOptions = useEntityOptions(entity);
  var listVariant = props.listVariant || contentOptions.listVariant || 'default';
  var embedComponents = useEmbedComponents();
  var LinkButton = useComponents().LinkButton;
  var t = useLang();
  var links = __spreadArray(__spreadArray([], __read(entity.link && [entity.link] || []), false), __read(entity.links || []), false);
  var pages = filter(__spreadArray(__spreadArray([], __read(entity.page && [entity.page] || []), false), __read(entity.pages || []), false), function (page) {
    return !page.disabled;
  });
  var contentComponents = listVariant === 'ticks' ? __assign(__assign({}, embedComponents), {
    li: function (props) {
      return React.createElement(ListItemWithIcon, {
        icon: TickIcon
      }, props.children);
    }
  }) : embedComponents;
  return React.createElement(EmbedComponentsProvider, {
    value: contentComponents
  }, React.createElement(My.Container, {
    colors: colors,
    center: center,
    className: cls.name(className)
  }, React.createElement(My.Titles, null, title && (titleHref ? React.createElement(My.TitleLink, {
    href: titleHref
  }, React.createElement(My.Title, null, title)) : React.createElement(My.Title, null, title)), afterTitle, subtitle && React.createElement(My.Subtitle, null, subtitle), afterSubtitle), React.createElement(My.Intro, {
    entity: entity
  }), afterIntro, hasContent && React.createElement(My.Content, {
    entity: entity
  }), afterContent, React.createElement(My.Buttons, {
    center: center
  }, links.map(function (link) {
    return React.createElement(My.LinkButton, {
      center: center,
      key: link.id,
      entity: link
    });
  })), children));
};
ContentEntityBlock.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;
// ContentEntityBlock.defaultProps = ContentEntityBlockDefaultProps;